import { loadStripe } from '@stripe/stripe-js';
import {ref} from "vue";

const clientSecret = ref('');
const stripe = ref(null);
const elements = ref(null);
const paymentElement = ref(null);

export const usePaymentElement = () => {
  const initializeStripe = async (options = {}) => {
    if (!stripe.value) {
      stripe.value = await loadStripe(process.env.MIX_STRIPE_KEY, options);
    }

    return stripe;
  };

  const createPaymentElement = async (options = {}) => {
    if (!stripe.value) {
      throw new Error('Stripe not initialized. Call initializeStripe first.');
    }

    const defaultOptions = {
      appearance: {
        theme: 'flat',
        variables: {
          colorPrimary: '#4CE0B3',
          colorPrimaryText: '#0B132B',
          colorBackground: '#ffffff',
          colorText: '#0B132B',
          colorDanger: '#F3625A',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          spacingUnit: '4px',
          borderRadius: '4px',
        },
        labels: 'auto',
        rules: {
          '.Input': {
            border: '1px solid #D8D8D8',
          },
          '.Tab': {
            border: '1px solid #D8D8D8',
          },
        },
      },
      ...options
    };

    elements.value = stripe.value.elements({
      clientSecret: clientSecret.value,
      ...defaultOptions
    });

    paymentElement.value = elements.value.create('payment', {
      layout: 'tabs',
      fields: {
        billingDetails: 'auto',
      },
    });

    return paymentElement;
  };

  const mountPaymentElement = (elementSelector) => {
    if (!paymentElement) {
      throw new Error('Payment element not created. Call createPaymentElement first.');
    }

    paymentElement.value.mount(elementSelector);
  };

  const confirmPayment = async (registrationToken, confirmationData = {}) => {
    if (!stripe.value || !elements.value) {
      throw new Error('Stripe or elements not initialized.');
    }

    if (!paymentElement.value) {
      throw new Error('Payment element not initialized');
    }

    const currentParams = new URLSearchParams(window.location.search);
    const redirectParams = new URLSearchParams({
      registrationToken: registrationToken,
    });

    if (currentParams.has('discount') || currentParams.has('d')) {
      redirectParams.set('discount', currentParams.get('discount') || currentParams.get('d'));
    }
    if (currentParams.get('package')) {
      redirectParams.set('package', currentParams.get('package'));
    }
    if (currentParams.get('duration')) {
      redirectParams.set('duration', currentParams.get('duration'));
    }

    const { error, paymentIntent } = await stripe.value.confirmPayment({
      elements: elements.value,
      confirmParams: {
        return_url: window.location.origin + '/register?' + redirectParams.toString(),
        ...confirmationData
      },
    });

    return { error, paymentIntent };
  };

  return {
    initializeStripe,
    createPaymentElement,
    mountPaymentElement,
    confirmPayment,
    paymentElement,
    stripe,
    elements,
    clientSecret,
  };
};
